import apiServices from "../../ApiServices/request-handler";
import { requestHandler } from "../../utils/functions";
import {
  setNotificationLoading,
  setNotifications,
} from "../slices/notificationSlice";

export const getNotifications = (onDone, loading = true) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: loading ? setNotificationLoading : null,
        apiService: apiServices.getNotificationsList,
        param_data: "",
        setData: setNotifications,
        isErrorMessage: false,
        onDone: (response) => onDone && onDone(response),
      })
    );
  };
};

export const readAllNotifications = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.readAllNotifications,
        isErrorMessage: false,
        onDone: () => onDone && onDone(),
      })
    );
  };
};

export const getNotificationsUnreadCount = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getNotificationsUnreadCount,
        onDone: (data) => onDone && onDone(data),
        isErrorMessage: false,
      })
    );
  };
};
